// ==============================================
// API URL Configuration
// ==============================================
// Production  : https://cms.dbshrineayanavaram.org/api
// Development : http://127.0.0.1:8000/api
//
// URL is automatically picked from .env / .env.local
// No need to manually switch — .env.local overrides .env locally.

export const ApiUrl = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000/api";

// Legacy commented references (kept for history):
// export const ApiUrl = "https://cms.lourdesshrineperambur.org/api";
// export const ApiUrl = "https://cms.dbshrineayanavaram.org/api";
// export const ApiUrl = "http://127.0.0.1:8000/api";